import React, { useState, useEffect } from 'react';
import { Button, Icon, Segment, List } from 'semantic-ui-react';
import { useSlackClient } from './slack.client';
import { InComponentErrorRenderer } from '../components/InComponentErrorRenderer';
export const SlackConnect = () => {
    const slackClient = useSlackClient();
    const [integrations, setIntegrations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    // Load existing integrations on component mount
    useEffect(() => {
        loadIntegrations();
    }, []);
    const loadIntegrations = async () => {
        try {
            setLoading(true);
            const data = await slackClient.getIntegrations();
            setIntegrations(data);
        }
        catch (err) {
            setError('Failed to load Slack integrations');
        }
        finally {
            setLoading(false);
        }
    };
    const handleSlackConnect = async () => {
        try {
            setLoading(true);
            setError(null);
            const { installUrl } = await slackClient.getInstallUrl();
            // Open Slack OAuth in a popup window
            const popup = window.open(installUrl, 'slack-oauth', 'width=600,height=700,scrollbars=yes,resizable=yes');
            // Poll for popup closure (indicates OAuth completion)
            const checkClosed = setInterval(() => {
                if (popup?.closed) {
                    clearInterval(checkClosed);
                    // Reload integrations after OAuth completion
                    setTimeout(() => {
                        loadIntegrations();
                    }, 1000);
                }
            }, 1000);
        }
        catch (err) {
            console.error('Error starting Slack OAuth:', err);
            setError('Failed to start Slack connection');
        }
        finally {
            setLoading(false);
        }
    };
    const handleDisconnect = async (teamId) => {
        try {
            setLoading(true);
            await slackClient.disconnectIntegration(teamId);
            await loadIntegrations(); // Reload the list
        }
        catch (err) {
            console.error('Error disconnecting Slack:', err);
            setError('Failed to disconnect Slack integration');
        }
        finally {
            setLoading(false);
        }
    };
    return (React.createElement(Segment, { style: { boxShadow: 'none', border: '1px solid #f0f0f0' } },
        error && React.createElement(InComponentErrorRenderer, { error: error }),
        integrations.length === 0 ? (React.createElement("div", null,
            React.createElement("p", { style: { color: '#666', marginBottom: '1em' } }, "Connect your Slack workspace to enable form filling through Slack messages."),
            React.createElement(Button, { color: "green", icon: true, labelPosition: "left", onClick: handleSlackConnect, loading: loading, disabled: loading },
                React.createElement(Icon, { name: "slack" }),
                "Connect to Slack"))) : (React.createElement("div", null,
            React.createElement("p", { style: { color: '#666', marginBottom: '1em' } }, "Connected Slack workspaces:"),
            React.createElement(List, { divided: true }, integrations.map((integration) => (React.createElement(List.Item, { key: integration.teamId, style: { padding: '0.5em 0' } },
                React.createElement(List.Content, { floated: "right" },
                    React.createElement(Button, { size: "tiny", color: "red", icon: "trash", onClick: () => handleDisconnect(integration.teamId), loading: loading, disabled: loading })),
                React.createElement(List.Content, null,
                    React.createElement(List.Header, null,
                        React.createElement(Icon, { name: "slack", color: "purple" }),
                        integration.teamName),
                    React.createElement(List.Description, { style: { fontSize: '0.85em', color: '#666' } },
                        "Connected on ",
                        new Date(integration.installedAt).toLocaleDateString(),
                        integration.isActive ? (React.createElement("span", { style: { color: '#28a745', marginLeft: '0.5em' } }, "\u2022 Active")) : (React.createElement("span", { style: { color: '#dc3545', marginLeft: '0.5em' } }, "\u2022 Inactive"))))))))))));
};
